module.exports = __webpack_public_path__ + "img/c_4.f67feb98.jpg";